import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
  },
});
//************************************ */
// Base de Datos
//************************************ */

//***** Acceso local
// const API_PORT = 3300;
// const API_SERVER = "10.0.0.212";

// Local HTTPS
//const API_SERVER = "10.0.0.212";
//const API_PORT = 443;

//***** Consulta en Producción
const API_SERVER = "api.gandara.cl";
const API_PORT = 443;

//***** Consulta desde Casa
//const API_SERVER = "201.236.92.107";
//const API_PORT = 45729;

export { API_SERVER, API_PORT }; // Exporta las variables fijas

export default store;
